import React, { useState, useEffect } from 'react';
import { supabase } from '../../supabaseClient';
import { useContact } from '../../contexts/ContactContext';

const AdminContact = () => {
  const { contactInfo, refetchContactInfo } = useContact();
  const [formData, setFormData] = useState({
    phone: '',
    email: '',
    address: '',
    business_hours: ''
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (contactInfo) {
      setFormData({
        phone: contactInfo.phone || '',
        email: contactInfo.email || '',
        address: contactInfo.address || '',
        business_hours: contactInfo.business_hours || ''
      });
    }
  }, [contactInfo]);

  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    setSaving(true);
    
    try {
      if (contactInfo.id) {
        // Update existing row
        const { error } = await supabase
          .from('site_settings')
          .update(formData)
          .eq('id', contactInfo.id);
        if (error) throw error;
      } else {
        // Insert new row if doesn't exist
        const { error } = await supabase
          .from('site_settings')
          .insert([formData]);
        if (error) throw error;
      }
      
      // Update global context so the rest of the app updates instantly without reload
      await refetchContactInfo();
      alert('Contact settings updated successfully!');
      
    } catch (error) {
      console.error('Error saving contact info:', error);
      alert('Failed to save: ' + error.message);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="p-8 min-h-screen bg-[#131313] text-white">
      <h2 className="text-3xl font-bold mb-6 text-[#f59e0b]" style={{ fontFamily: 'Bebas Neue' }}>Manage Contact Details</h2>
      
      <div className="bg-[#1c1b1b] p-6 rounded-xl border border-white/10 mb-8 shadow-xl max-w-3xl">
        <h3 className="text-xl font-semibold mb-6 text-[#d8c3ad]">Edit Global Contact Info</h3>
        
        <form onSubmit={handleSave} className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="md:col-span-1">
            <label className="block text-gray-400 text-sm font-bold mb-2">Phone Number</label>
            <input 
              type="text" 
              name="phone" 
              value={formData.phone} 
              onChange={handleInputChange} 
              placeholder="+91 99167 10011"
              className="bg-[#0e0e0e] border border-white/10 rounded px-4 py-3 text-white w-full focus:border-[#f59e0b] focus:outline-none transition-colors" 
              required
            />
          </div>
          
          <div className="md:col-span-1">
            <label className="block text-gray-400 text-sm font-bold mb-2">Email Address</label>
            <input 
              type="email" 
              name="email" 
              value={formData.email} 
              onChange={handleInputChange} 
              placeholder="info@hbb0011realty.com"
              className="bg-[#0e0e0e] border border-white/10 rounded px-4 py-3 text-white w-full focus:border-[#f59e0b] focus:outline-none transition-colors" 
              required
            />
          </div>
          
          <div className="md:col-span-2">
            <label className="block text-gray-400 text-sm font-bold mb-2">Business Hours</label>
            <input 
              type="text" 
              name="business_hours" 
              value={formData.business_hours} 
              onChange={handleInputChange} 
              placeholder="Mon - Sat: 9:00 AM - 6:00 PM"
              className="bg-[#0e0e0e] border border-white/10 rounded px-4 py-3 text-white w-full focus:border-[#f59e0b] focus:outline-none transition-colors" 
            />
          </div>
          
          <div className="md:col-span-2">
            <label className="block text-gray-400 text-sm font-bold mb-2">Office Address</label>
            <textarea 
              name="address" 
              value={formData.address} 
              onChange={handleInputChange} 
              rows="3"
              placeholder="Full office address..."
              className="bg-[#0e0e0e] border border-white/10 rounded px-4 py-3 text-white w-full focus:border-[#f59e0b] focus:outline-none transition-colors" 
              required
            />
          </div>
          
          <div className="md:col-span-2 pt-4 border-t border-white/10 flex justify-end">
            <button 
              type="submit" 
              disabled={saving}
              className={`font-bold py-3 px-8 rounded transition-colors flex justify-center items-center gap-2 ${saving ? 'bg-gray-600 text-gray-300 cursor-not-allowed' : 'bg-[#f59e0b] text-[#2a1700] hover:bg-[#ffc174]'}`}
            >
              {saving ? (
                <>
                  <span className="material-symbols-outlined animate-spin text-sm">sync</span>
                  Processing...
                </>
              ) : (
                'Save Changes'
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminContact;
